import React from "react";
import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { useLang } from "@/context/LanguageContext";
import { ShieldCheck, Sparkles, TrendingUp, LogIn } from "lucide-react";
import { FormCard } from "@/components/FormShell";

export default function AuthShell({ children, title, subtitle, icon = LogIn }) {
  const { t } = useLang();
  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      {/* Brand panel */}
      <div className="hidden lg:flex flex-col justify-between findo-gradient text-white p-12 relative overflow-hidden">
        <div className="absolute inset-0 hero-mesh opacity-40" />
        <Link to="/" className="relative z-10 flex items-center">
          <Logo size={40} withText textClass="text-2xl text-white" />
        </Link>
        <div className="relative z-10 space-y-8 max-w-md">
          <h2 className="font-display text-4xl font-extrabold leading-tight">
            {t("shell.title")}
          </h2>
          <ul className="space-y-4">
            {[
              { Icon: Sparkles, t: t("shell.f1t"), d: t("shell.f1d") },
              { Icon: TrendingUp, t: t("shell.f2t"), d: t("shell.f2d") },
              { Icon: ShieldCheck, t: t("shell.f3t"), d: t("shell.f3d") },
            ].map(({ Icon, t: title2, d }) => (
              <li key={title2} className="flex gap-3">
                <span className="h-10 w-10 shrink-0 grid place-items-center rounded-xl bg-white/15">
                  <Icon size={20} />
                </span>
                <span>
                  <span className="block font-bold">{title2}</span>
                  <span className="block text-sm text-white/80">{d}</span>
                </span>
              </li>
            ))}
          </ul>
        </div>
        <p className="relative z-10 text-sm text-white/70">© {new Date().getFullYear()} findloop</p>
      </div>

      {/* Form panel */}
      <div className="flex items-center justify-center p-6 sm:p-12 bg-white">
        <div className="w-full max-w-md animate-fade-up">
          <Link to="/" className="lg:hidden flex justify-center mb-8">
            <Logo size={40} withText textClass="text-2xl text-slate-900" />
          </Link>
          <h1 className="sr-only">{title}</h1>
          <FormCard icon={icon} title={title} subtitle={subtitle} testid="auth-form-card">{children}</FormCard>
        </div>
      </div>
    </div>
  );
}
